import React, { useContext } from "react";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  Box,
  Step,
  StepIconProps,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import { observer } from "mobx-react-lite";
import { makeStyles } from "tss-react/mui";

import MealPlanFormStore from "./store/MealPlanFormStore";

interface Props {
  className?: string;
  title: string;
  steps: string[];
}

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "16px",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  stepper: {
    width: 400,
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
}));

const useQontoStepIconStyles = makeStyles()((theme) => ({
  root: {
    color: "#eaeaf0",
    display: "flex",
    height: 12,
    width: 12,
    alignItems: "center",
  },
  active: {
    color: "transparent",
    border: `3px solid ${theme.palette.primary.main}`,
    borderRadius: "100%",
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
  completed: {
    color: theme.palette.primary.main,
    zIndex: 1,
    fontSize: 16,
  },
}));

function QontoStepIcon(props: StepIconProps) {
  const { classes, cx } = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={cx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? (
        <CheckCircleIcon className={classes.completed} />
      ) : (
        <div className={classes.circle} />
      )}
    </div>
  );
}

const Header: React.FC<Props> = observer(({ className, title, steps }) => {
  const { classes, cx } = useStyles();

  const store = useContext(MealPlanFormStore.Context);
  const activeStep = store.currentStep;

  return (
    <div className={cx(classes.root, className)}>
      <Typography fontWeight={700} sx={{ fontSize: "1.75em" }}>
        {title}
      </Typography>
      <Box marginBottom={4} />
      <Stepper className={classes.stepper} activeStep={activeStep}>
        {steps.map((step, i) => (
          <Step key={i}>
            <StepLabel StepIconComponent={QontoStepIcon}>{step}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
});

export default Header;
